<h2 mat-dialog-title>Connection Error</h2>
<mat-dialog-content>
  <p>The connection to the internet has been lost. Please check your network settings.</p>
</mat-dialog-content>